/**
 * Header Mega Menu
 * @desc If a desktop menu is open and the viewport shrinks to mobile, we want to close the menu
 * @returns {Function}init
 */
function headerMegaMenu() {
  const c = {
    dom: {
      megaMenu: '[data-mega-menu-nav]',
      details: 'details'
    },
    attr: {
      open: 'open'
    },
    breakpoint: {
      desktop: "(min-width: 990px)",
    }
  };
  const $megaMenu = document.querySelector(c.dom.megaMenu);

  function init() {
    if (!$megaMenu) return;
    addEvents();
  }

  function addEvents() {
    window.addEventListener('resize', handleWindowResize);
  }

  function handleWindowResize() {
    const $openMenu = $megaMenu.querySelector(`${c.dom.details}[${c.attr.open}]`)
    const isDesktop = window.matchMedia(`${c.breakpoint.desktop}`).matches;
    if ($openMenu && !isDesktop) {
      $openMenu.removeAttribute(c.attr.open)
    }
  }

  return init();
}
headerMegaMenu()